import React from 'react';

import { PropToEdit, FieldTypeSchemas, EnumFieldType } from 'craft/types';

import BooleanField from './BooleanField';
import DateField from './DateField';
import EnumField from './EnumField';
import NumberField from './NumberField';
import TextField from './TextField';

interface Props {
  nodeIds: string[];
  propToEdit: PropToEdit;
}

const PropertyField = ({ nodeIds, propToEdit }: Props) => {
  switch (propToEdit.schema.fieldType.type) {
    case FieldTypeSchemas.Bool:
      return <BooleanField nodeIds={nodeIds} propToEdit={propToEdit} />;

    case FieldTypeSchemas.Enum:
      return <EnumField nodeIds={nodeIds} propToEdit={propToEdit as PropToEdit<EnumFieldType>} />;

    case FieldTypeSchemas.Number:
      return <NumberField nodeIds={nodeIds} propToEdit={propToEdit} />;

    case FieldTypeSchemas.String:
      return <TextField nodeIds={nodeIds} propToEdit={propToEdit} />;

    case FieldTypeSchemas.Date:
      return <DateField nodeIds={nodeIds} propToEdit={propToEdit} />;

    default:
      return null;
    // throw new Error('Proptype schema not recognized');
  }
};

export default PropertyField;
